import {threshold} from '@/store/state'

export function isDelayed(timeEntry: Pick<Dbi.TimeEntry, 'sign' | 'diff'> | undefined, delayTime?: number): boolean {
    delayTime ??= threshold.delayRed
    return !!(timeEntry && timeEntry.sign === '+' && timeEntry.diff >= delayTime)
}
